import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FicheLogTerminal from "./journal";
import { Tag } from "primereact/tag";
import mapEtatFicheLead from "../mapEtatFicherLead";
import { TextField, TextareaAutosize } from "@mui/material";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import formatToISODate from "../formatDateISO";
import { Calendar } from "primereact/calendar";
import DevisDialog from "./DevisDialog";
import formatDateTimeMadagascar from "../convertTime";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import { format } from "date-fns";
import convertTimeStringToDate from "../timeToDate";

import {
  formatDateWithDaysAgo,
  clientTemplate,
  contactTemplate,
  invitesTemplate,
  typeTemplate,
  nameTemplate,
  phoneTemplate,
  emailTemplate,
  amountTemplate
} from './formatTableau';


const apiUrl = process.env.REACT_APP_API_URL;

export default function ToutesFiches({ searchTerm = "" }) {
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);

  const [ficheLeadsToutes, setFicheLeadsToutes] = useState([]);

  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [openSnackbarMail, setOpenSnackbarMail] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [visible, setVisible] = useState(false);

  const [rechercheNouvelles, setRechercheNouvelles] = useState("");

  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [leadToDelete, setLeadToDelete] = useState(null);

  const [tempIdFicheLead, setTempIdFicheLead] = useState("");
  const [tempNom, setTempNom] = useState("");
  const [tempEmail, setTempEmail] = useState("");
  const [tempTel, setTempTel] = useState("");
  const [tempLieu, setTempLieu] = useState("");
  const [tempNbpers, setTempNbpers] = useState("");
  const [tempHeuredebut, setTempHeuredebut] = useState("");
  const [tempTypeBar, setTempTypeBar] = useState("");
  const [tempBarman, setTempBarman] = useState("");
  const [tempMore, setTempMore] = useState("");
  const [nbAppels, setNbAppels] = useState("");
  const [tempDateEvent, setTempDateEvent] = useState("");

  const [ficheListeFiltreToutes, setFicheListeFiltreToutes] = useState("");
  const [note, setNote] = useState("");

  const [appel, setAppel] = useState("");
  const [date, setDate] = useState(null);
  const [dateDevis, setDateDevis] = useState(null);
  const [dateValidation, setDateValidation] = useState(null);

  const [tempStatus, setTempStatus] = useState("");

  const [heureDem, setHeureDem] = useState("");
  const [devisDialogVisible, setDevisDialogVisible] = useState(false);
  const [currentLeadForDevis, setCurrentLeadForDevis] = useState(null);

  const [forceNewDevis, setForceNewDevis] = useState(false);
  

  const openDevisDialog = (leadData, isNew = false) => {
    setForceNewDevis(isNew);
    setCurrentLeadForDevis({
      idLead: leadData.idLead,
      nomPrenom: leadData.nomPrenom,
      email: leadData.email,
      tel: leadData.tel,
      lieu: leadData.lieu,
      type_bar:leadData.type_bar,
      dateEvent:leadData.dateFicheLead,
      nbpers: leadData.nbpers,
      plusInfos:leadData.more
    });
    setDevisDialogVisible(true);
  };

  const handleDevisGenerated = () => {
    axios
      .get(`${apiUrl}/IHM/api/lead.php?toutes`)
      .then((response) => {
        setFicheLeadsToutes(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du rechargement :", error);
      });
  };

  const getLabel = () => {
    switch (appel) {
      case "0":
        return "Nouvelle";
      case "1":
        return "En cours";
      case "2":
        return "Suivis";
      case "3":
        return "Validés";
      case "4":
        return "Réalisés";
      case "5":
        return "Abandons";
      default:
        return "inconnus";
    }
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error,
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleCloseSnackbarMail = () => {
    setOpenSnackbarMail(false);
  };

  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/lead.php?toutes`)
      .then((response) => {
        setFicheLeadsToutes(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des factures :", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const recherche = searchTerm.toLowerCase();
    const filteredList = ficheLeadsToutes.filter((fiche) => {
      const nomPrenom = fiche.nomPrenom?.toLowerCase() || "";
      const tel = fiche.tel?.toLowerCase() || "";
      const lieu = fiche.lieu?.toLowerCase() || "";
      const email = fiche.email?.toLowerCase() || "";
      return (
        nomPrenom.includes(recherche) ||
        tel.includes(recherche) ||
        lieu.includes(recherche) ||
        email.includes(recherche)
      );
    });
    setFicheListeFiltreToutes(filteredList);
  }, [searchTerm, ficheLeadsToutes]);



  const handleDeleteLead = async () => {
    if (!leadToDelete) return;

    try {
      await axios.post(`${apiUrl}IHM/api/delete_lead.php`, {
        idLead: leadToDelete.idLead,
        submissionId: leadToDelete.idSubmissions,
      });
      setDeleteDialogVisible(false);
      setLeadToDelete(null);

      window.location.reload();
    } catch (error) {
      console.error("Erreur de suppression :", error);
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbarMail}
        autoHideDuration={1000}
        onClose={handleCloseSnackbarMail}
        message={snackbarMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbarMail}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <DevisDialog
        visible={devisDialogVisible}
        onHide={() => {
          setDevisDialogVisible(false);
          setForceNewDevis(false);
        }}
        leadData={currentLeadForDevis}
        onDevisGenerated={() => {
          handleDevisGenerated();
          setForceNewDevis(false);
        }}
        forceNew={forceNewDevis}
      />
      <Dialog
        visible={deleteDialogVisible}
        header="Confirmation de suppression"
        modal
        className="custom-dialog"
        style={{ width: "30vw" }}
        onHide={() => {
          setDeleteDialogVisible(false);
          setLeadToDelete(null);
        }}
        footer={
          <div className="flex justify-content-end gap-2">
            <Button
              label="Annuler"
              icon="pi pi-times"
              severity="secondary"
              text
              onClick={() => {
                setDeleteDialogVisible(false);
                setLeadToDelete(null);
              }}
            />
            <Button
              label="Supprimer"
              icon="pi pi-trash"
              className="p-button-danger"
              onClick={handleDeleteLead}
            />
          </div>
        }
      >
        <div className="p-3">
          <p>Êtes-vous sûr de vouloir supprimer ce lead ?</p>
          <p className="text-sm text-gray-500">
            Client: <strong>{leadToDelete?.nomPrenom || ""}</strong>
          </p>
          <p className="text-sm text-gray-500">
            Cette action est irréversible.
          </p>
        </div>
      </Dialog>
      <DataTable
        value={ficheListeFiltreToutes}
        paginator
        size="small"
        rows={100}
        rowsPerPageOptions={[100, 200]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {ficheListeFiltreToutes.length}
          </span>
        }
        loading={loading}
        loadingIcon="pi pi-spin pi-spinner"
        emptyMessage={
          loading
            ? "Chargement des nouvelles fiches..."
            : "Aucune fiche pour le moment"
        }
      >
        <Column
          body={(rowData) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                icon="pi pi-trash"
                severity="danger"
                size="small"
                text
                onClick={() => {
                  setLeadToDelete(rowData);
                  setDeleteDialogVisible(true);
                }}
              />
            </div>
          )}
          style={{ width: "60px", textAlign: "center" }}
          bodyStyle={{ textAlign: "center" }}
        />

        <Column
          field="dateUpdate"
          header="Date"
          body={(rowData) => formatDateWithDaysAgo(rowData.dateUpdate)}
        />

        <Column
          field="nom"
          header="Client"
          body={(rowData) => nameTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="email"
          header="Contact"
          body={(rowData) => contactTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="nbpers"
          header="Invités"
          body={(rowData) => invitesTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="type_bar"
          header="Type"
          body={(rowData) => typeTemplate(rowData)}
        />

        <Column
          field="etat"
          header="Statut"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            const statusColor = rowData.color || "#6b7280";

            const backgroundColor = `${statusColor}15`;

            return (
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "4px 14px",
                  borderRadius: "20px",
                  backgroundColor: backgroundColor,
                  color: statusColor,
                  fontSize: "13px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                  border: `1px solid ${statusColor}30`,
                }}
              >
                <span
                  style={{
                    height: "6px",
                    width: "6px",
                    borderRadius: "50%",
                    backgroundColor: statusColor,
                  }}
                ></span>

                {rowData.status}
              </div>
            );
          }}
        />

        {/* <Column
          field="note"
          header="Dernier MAJ"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            if (!rowData.dateUpdate) return null;

            const date = new Date(rowData.dateUpdate);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <span style={{ fontSize: "13px" }}>
                {formatDateTimeMadagascar(rowData.dateUpdate)} <br />
                {rowData.adminNote}
              </span>
            );
          }}
        /> */}

        <Column
          header="Actions"
          style={{ textAlign: "center", width: "100px" }}
          body={(rowData) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              {rowData.a_devis == 1 ? (
                <>
                  <Button
                    icon="pi pi-file-pdf"
                    severity="info"
                    text
                    raised
                    size="small"
                    tooltip="Gérer le devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData, false)}
                  />
                   <Button
                    icon="pi pi-plus"
                    severity="warning"
                    text
                    raised
                    size="small"
                    tooltip="Nouveau devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData, true)}
                  />
                </>
              ) : (
                <>
                  <Button
                    icon="pi pi-file-pdf"
                    severity="danger"
                    size="small"
                    text
                    raised
                    tooltip="Générer le devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData)}
                  />
                 
                </>
              )}
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
